// 在 url 中添加 hiddennavigationbar=true 可以隐藏 app 原生页头
import { callApp, TData, TCallBack, registerAppHandler } from 'base/utils/bridge'
import site from 'pro/config/site'
import { nativePages } from 'base/config/native-pages';
import { getStoreState, syncGlobalStore } from 'base/store';
import {
    APP_FIRST_ENTRY,
    COOKIE_ACCESS_TOKEN,
    COOKIE_COUNTRY,
    COOKIE_CURRENCY,
    COOKIE_LOGIN_TOKEN
} from 'base/config/constant';
import { setCookie, delCookie, getCookie } from 'ava-util/dist/cookie';
import { getParamInSearch } from 'ava-util/dist/request';
import { DEBUG_APP } from '../config/constant';
import { getNewLangPathname, getQueryInUrl } from 'base/utils/request';
import { updateSearch } from 'ava-util/dist/request';
import { ILinkItem } from '@base/lib/share/interface';
import { IBuyNowData } from 'base/interfaces/checkout'

const APP_LINK_ROOT = site.appLinkRoot

type TimerType = ReturnType<typeof setTimeout>;

let jumpTimer: TimerType; //页面跳转 timer
const timerList: Record<string, TimerType> = {}; //短时间内连续点击，key（name）相同的方法仅执行最后一次

export function isApp(userAgent?: string): boolean {
    if (!userAgent) {
        userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    }
    return /(sn-App)/i.test(userAgent) || getParamInSearch(DEBUG_APP) === '1';
}

export function isRealApp(userAgent?: string): boolean {
    if (!userAgent) {
        userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    }
    return /(sn-App)/i.test(userAgent);
}

// 短时间内连续点击，name相同的方法仅执行最后一次
// throttle('goLogin', () => {
//     callApp('goLogin', callback)
// });
function throttle(name: string, data?: TData | TCallBack, callback?: TCallBack) {
    if (timerList[name]) {
        clearTimeout(timerList[name]);
    }
    timerList[name] = setTimeout(() => {
        callApp(name, data, callback);
        delete timerList[name];
    }, 300)
}

// 跳转app原生页面
function goNativePage(nativeLink: string) {
    console.log('goNativePage', APP_LINK_ROOT + nativeLink.replace(APP_LINK_ROOT, ''))
    clearTimeout(jumpTimer)
    jumpTimer = setTimeout(() => {
        window.location.href = APP_LINK_ROOT + nativeLink.replace(APP_LINK_ROOT, '')
    }, 300)
}

// 跳转到原生列表页
export function goNativeList(listSn: string) {
    goNativePage(`/productList?listId=${listSn}`)
}

// 跳转到原生商品页
export function goNativeProduct(productId: string, variantId?: string) {
    if (variantId) {
        goNativePage(`/productDetails?spuId=${productId}&variantId=${variantId}`);
    } else {
        goNativePage(`/productDetails?spuId=${productId}`);
    }
}

// 获取用户信息
export function getNativeUserInfo(callback: TCallBack) {
    callApp('nativeUserStatus', callback)
}

// 唤起原生登录注册
export function nativeLogin(callback?: TCallBack) {
    throttle('nativeLoginPage', (res: {
        userId: string;
        loginToken: string;
        accessToken: string;
    }) => {
        console.log('nativeLogin res', res);
        // app中原生登录后，更新cookie
        if (res.loginToken) {
            setCookie(COOKIE_LOGIN_TOKEN, res.loginToken);
        } else {
            delCookie(COOKIE_LOGIN_TOKEN);
        }
        setCookie(COOKIE_ACCESS_TOKEN, res.accessToken);
        syncGlobalStore('userStore', res);
        callback && callback(res);
    });
}


// 第一层path
const getPath1 = (pathname: string) => {
    let path1 = ''
    if (pathname.includes('://')) {
        path1 = pathname.split('://')?.[1]?.split('/')[1]
    } else {
        path1 = pathname.split('/')[1]
    }

    return path1
}

//获取支持的原生页面配置
export function getNativePage(pathname: string) {

    const path1 = getPath1(pathname);

    return nativePages.find(item => item.url === pathname || (item.reg && item.reg.test(path1)))
}

// 通知 app 更新购物车数量
export function nativeCartNum(cartNum: number) {
    throttle('nativeCartNum', { cartNum });
}

// Buy Now
type INativeBuyNowParams = IBuyNowData & {
    variantNums: Array<{ variantId: string; num: number; }>;
    source?: string;
    cacheKey?: string;
};

export function nativeBuyNow(params: INativeBuyNowParams) {
    const { variantNums, source, cacheKey, ...restParams } = params;
    const { userId } = getStoreState('userStore');
    const data: Record<string, any> = {
        ...restParams,
        userId,
        productItems: variantNums.map(item => ({
            productVariantId: item.variantId,
            num: item.num
        }))
    };
    if (!!source) {
        data.source = source;
    }
    if (!!cacheKey) {
        data.cacheKey = cacheKey;
    }
    throttle('nativeCheckoutFromBuyNow', data);
}

//配置native导航栏右侧按钮
export function nativeNavigationConfig(configs: Array<{
    type: 'cart' | 'help';
    webLink?: string;
    appLink?: string;
}>) {

    callApp('nativeNavigationItemConfig', {
        configs: configs.map(item => {
            const _item = { ...item };
            if (_item.webLink && !/^(http:|https:)*\/\//.test(_item.webLink)) {
                _item.webLink = window.location.origin + (_item.webLink.startsWith('/') ? '' : '/') + _item.webLink;
            }
            return _item
        }).reverse()
    });
}

// 退出 web，返回 native 页面
export function nativGoBack() {
    throttle('nativeWebViewGoBack');
}

export function nativeGetStorage(key: string): Promise<string | null> {
    return new Promise((resolve) => {
        callApp('GetDataFromNative', { key }, res => {
            resolve(!res ? null : (typeof res === 'string' ? res : JSON.stringify(res)));
        });
    });
}

export function nativeSetStorage(key: string, value: string, source?: string) {
    callApp('StashDataToNative', { key, value, source });
}

export function nativeRemoveStorage(key: string): Promise<boolean> {
    return new Promise((resolve) => {
        callApp('DeleteDataToNative', { keys: [key] }, () => {
            resolve(true);
        });
    });
}

const checkObjIncludes = (obj = {}, compareObj = {}): boolean => {
    const keys = Object.keys(obj)
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        const oVal = obj[key]
        const cOVal = compareObj[key]

        if (!oVal) {
            if (!oVal != !cOVal) {
                return false
            }
        } else if (oVal != cOVal) {
            return false
        }
    }
    return true
}

export function webReloadCallback(res) {
    if (!res) {
        console.log('webReload response undefined');
        return;
    }

    const pathname = getNewLangPathname(window.location.pathname);
    const search = {
        country: res.country || void 0,
        currency: res.currency || void 0,
        login_token: res.login_token || void 0,
        access_token: res.access_token || void 0,
    }

    const preCookies = {
        country: getCookie(COOKIE_COUNTRY),
        currency: getCookie(COOKIE_CURRENCY),
        login_token: getCookie(COOKIE_LOGIN_TOKEN),
        access_token: getCookie(COOKIE_ACCESS_TOKEN),
    }

    const urlSearch = window.location.search
    const urlQueries = getQueryInUrl(urlSearch)

    const preQueries = {
        ...preCookies,
        ...urlQueries
    }

    // 检查search 是否一样 不一样刷新
    if (!checkObjIncludes(search, preQueries)) {
        search['-t'] = (new Date()).getTime()

        const newSearch = updateSearch(search, urlSearch);

        const hash = window.location.hash;
        const href = pathname + newSearch + (hash.startsWith('#drawer-') ? '' : hash);
        // window.location.href = href;
        window.location.replace(href)
    }
}

// web通过native进行打点
export function nativeTrack(eventType: 'pv' | 'ctrImpressions' | 'ctrClick' | 'productImpressions' | 'productClick' | 'addToCart', tracks: Array<Record<string, any>>) {
    callApp('trackToNative', {
        eventType,
        tracks,
    });
}

export function nativeCopy(text: string, callback?: () => void) {
    throttle('CopyContentToNative', { text }, callback);
}

export type INativeShareData = {
    links: ILinkItem[];
    text?: string;
    images?: string[];
}

export function nativeShare(data: INativeShareData, clickItemCallback?: () => void) {
    throttle('ShareContentToNative', data, clickItemCallback);
}

function appGoBackHistory(query) {
    if (isApp() && query[APP_FIRST_ENTRY] == '1') {
        console.log('back to app')
        nativGoBack();
    } else {
        console.log('back to pre page')
        window.history.back();
    }
}

export function initRegisterAppHandler(query) {
    // app 初次访问页面或跳出后重新回到页面时调用
    registerAppHandler('webReload', webReloadCallback);
    // app 导航返回
    registerAppHandler('appNavGoBack', () => {
        appGoBackHistory(query)
    });
}